import { viewActionCreators } from '@opengov/component-library-classic/module/view';
import type { Editor as TinyMCE } from 'tinymce/tinymce';
import { AiApi, AiGeneratedSummaryLength } from '../../../../../../../../api/ai-api';
import { IEditorMessages } from '../../../../../../../../types';
import { extractErrorMsg } from '../../../../../../../utils/errors';

type ImageContextMenu = {
  editor: TinyMCE;
  setIsGenerating: (isGenerating: boolean) => void;
  setExplanation: (explanation: string) => void;
  messages: IEditorMessages;
  entityId: number;
};

export const TEXT_SELECTION = 'text-selection';
export const TEXT_AI_MENU_ITEM = 'ai-text-explain-this';

export function addTextContextMenuToEditor({
  entityId,
  editor,
  setIsGenerating,
  messages,
  setExplanation
}: ImageContextMenu) {
  editor.ui.registry.addMenuItem(TEXT_AI_MENU_ITEM, {
    icon: 'ai',
    text: messages.contextMenus.explainThis,
    async onAction() {
      const selectedText = editor.selection.getContent({ format: 'text' });
      setIsGenerating(true);

      try {
        const explanation = await AiApi.submitQuestion({
          entityId,
          userPrompt: selectedText,
          contentLength: AiGeneratedSummaryLength.SHORT,
          verbose: false
        });
        setExplanation(explanation);
      } catch (error) {
        console.error(error);
        viewActionCreators.showCapitalToast({
          title: messages.somethingWentWrongError,
          body: extractErrorMsg(error, messages.unableToGenerateAnswer),
          variant: 'failure'
        });
      } finally {
        setIsGenerating(false);
      }
    }
  });

  editor.ui.registry.addContextMenu(TEXT_SELECTION, {
    update(_element) {
      if (editor.selection.getContent({ format: 'text' }).trim() !== '') {
        return `${TEXT_AI_MENU_ITEM} link`;
      }
      return '';
    }
  });
}
